import request from "./../utils/request";

export async function getHalfMadeProductList(payload) {
  return request.get("HalfMadeProduct/List", {
    params: {
      branchId: payload.branch ? payload.branch.id : null,
      halfMadeId: payload.halfMade ? payload.halfMade.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      minCost: payload.cost && payload.cost.min ? payload.cost.min : null,
      maxCost: payload.cost && payload.cost.max ? payload.cost.max : null,
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
    }
  });
}
export async function createNewHalfMadeProduct(newProductCategory) {
  return request.post("HalfMadeProduct/Create", newProductCategory);
}
export async function updateHalfMadeProduct(productCategory) {
  return request.post("HalfMadeProduct/Update", productCategory);
}
export async function deleteHalfMadeProduct(id) {
  return request.delete('HalfMadeProduct/Delete?id=' + id);
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}
